module.exports = __webpack_public_path__ + "img/Stelle_Betrieb.51a6e40a.svg";